(() => {
 const root=document.querySelector('.home-editorial');if(!root)return;
 const accordion=root.querySelector('.accordion');
 let panels=[...root.querySelectorAll('.product-panel')];
 const reduce=matchMedia('(prefers-reduced-motion:reduce)');
 const phone=matchMedia('(max-width:700px)');
 function select(index){panels.forEach((panel,i)=>{panel.classList.toggle('active',i===index);panel.querySelector('button').setAttribute('aria-pressed',String(i===index));});}
 // phone only: once a tapped piece has opened, bring its whole stage into view (the panel's scroll-margin keeps it clear of the floating header)
 function reveal(panel){
  if(!phone.matches)return;
  setTimeout(()=>{
   if(!panel.classList.contains('active'))return;
   const r=panel.getBoundingClientRect(),cs=getComputedStyle(panel);
   if(r.top<parseFloat(cs.scrollMarginTop)||r.bottom>innerHeight-parseFloat(cs.scrollMarginBottom))panel.scrollIntoView({block:'nearest',behavior:reduce.matches?'auto':'smooth'});
  },reduce.matches?0:820);
 }
 function bind(){
  panels.forEach((panel,i)=>{
   const button=panel.querySelector('button');
   // on the panel: a touch tap that focuses the button features the panel at once, the stage's link overlay is then
   // under the finger and the click lands on the panel itself, not on the button
   panel.addEventListener('click',e=>{if(e.target.closest('.panel-link'))return;select(i);reveal(panel)});
   button.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')select(i)});
   panel.addEventListener('focusin',()=>select(i));
   button.addEventListener('keydown',e=>{const next=e.key==='ArrowRight'||e.key==='ArrowDown'?1:e.key==='ArrowLeft'||e.key==='ArrowUp'?-1:0;if(next){e.preventDefault();panels[(i+next+panels.length)%panels.length].querySelector('button').focus();}});
  });
 }
 bind();
 root.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.decoding='async'});

 /* The sale edit follows Shopify (2026-11-04, the owner: "the homepage sale section should also be editable"): its words
    and the products it features come from the store's "Homepage sale" entry (metaobject alda_home_sale/homepage-sale),
    and what is on sale from Shopify's prices (commerce.js, 'alda:prices'). Up to four pieces, the client's picks first
    while they are on sale, then the deepest other cuts (one per line before a second from the same line). With nothing
    on sale, or the entry's "Show on the homepage" unticked, the section goes. Until both answers are in - or if
    Shopify can't be reached - the section stays as built. */
 const sale=root.querySelector('.stage-sale');
 if(sale&&accordion){
  const KEY='alda_home_sale',TTL=60*1000,MAX=4;
  const built=panels.map(p=>(p.querySelector('.panel-link')?.getAttribute('href')||'').split('/').pop());
  // the entry: {show, eyebrow, headline, picks: [handle]}, or null when the store has none or can't be asked
  function settings(){
   try{const c=JSON.parse(sessionStorage.getItem(KEY)||'null');if(c&&Date.now()-c.t<TTL)return Promise.resolve(c.v);}catch(e){}
   const S=window.aldaShop;
   if(!S||!S.ready())return Promise.resolve(null);
   return S.query('{ metaobject(handle: {type: "alda_home_sale", handle: "homepage-sale"}) { fields { key value references(first: 4) { nodes { ... on Product { handle } } } } } }').then(d=>{
    const m=d&&d.metaobject;
    if(!m)return null;
    const f={};m.fields.forEach(x=>{f[x.key]=x;});
    const text=k=>(f[k]&&f[k].value||'').trim();
    const v={show:text('show_section')!=='false',eyebrow:text('eyebrow').slice(0,40),headline:text('headline').slice(0,80),
     picks:f.products&&f.products.references?f.products.references.nodes.map(n=>n.handle).filter(Boolean):[]};
    try{sessionStorage.setItem(KEY,JSON.stringify({t:Date.now(),v}));}catch(e){}
    return v;
   },()=>null);
  }
  const asked=settings();
  // the words, as soon as they are in: a new line in the headline box is a new line on the page
  asked.then(s=>{
   if(!s)return;
   const eyebrow=sale.querySelector('.eyebrow'),h2=sale.querySelector('h2');
   if(s.eyebrow&&eyebrow)eyebrow.textContent=s.eyebrow;
   if(s.headline&&h2){h2.replaceChildren();s.headline.split(/\r?\n/).map(l=>l.trim()).filter(Boolean).forEach((l,i)=>{if(i)h2.append(document.createElement('br'));h2.append(l);});}
  });
  const P=()=>window.aldaPrice;
  const onSale=f=>!!f&&!f.variants.every(v=>v.soon)&&P().famPct(f)>0;
  // the pieces to feature: the entry's picks (with no entry to read, the ones the page was built with), then the rest
  function choose(s){
   const all=[];
   (s&&s.picks&&s.picks.length?s.picks:s?[]:built).forEach(slug=>{const f=P().family(slug);if(onSale(f)&&!all.includes(f))all.push(f);});
   if(all.length<MAX){
    // the deepest cuts, catalogue order between equals; one per line (or shelf) first, so the edit shows a spread
    return P().catalogue().then(c=>{
     if(!c)return all.slice(0,MAX);
     const rest=c.data.families.filter(f=>onSale(f)&&!all.includes(f)).map((f,i)=>({f,i,pct:P().famPct(f)})).sort((a,b)=>b.pct-a.pct||a.i-b.i).map(x=>x.f);
     const lineOf=f=>f.line||f.sub,used=new Set(all.map(lineOf));
     rest.filter(f=>!used.has(lineOf(f))&&used.add(lineOf(f))).concat(rest).forEach(f=>{if(all.length<MAX&&!all.includes(f))all.push(f);});
     return all;
    });
   }
   return Promise.resolve(all.slice(0,MAX));
  }
  // a piece's price line as the edit writes it: 'from ₹1,163 ~~₹1,550~~' (the lowest selling price, its MRP struck)
  function priceLine(f,box){
   const p=P(),lo=p.from(f),lead=p.lead(f)||'';
   box.replaceChildren(lead+p.rupees(p.price(lo)));
   if(p.onSale(lo)){box.append(' ');const s=document.createElement('s');s.textContent=p.rupees(lo.mrp);box.append(s);}
   return box;
  }
  function panel(f,i){
   const a=document.createElement('article');a.className='product-panel'+(i?'':' active');
   const name=f.shortName||f.name;
   a.innerHTML='<button class="panel-select"></button><span class="panel-no"></span><img loading="lazy" decoding="async" alt="" draggable="false"><a class="round panel-link">↗</a><div class="panel-copy"><h3></h3><div class="price"></div></div>';
   const b=a.querySelector('button');b.dataset.product=i;b.setAttribute('aria-pressed',String(!i));b.setAttribute('aria-label','Feature '+name);
   a.querySelector('.panel-no').textContent=String(i+1).padStart(2,'0');
   const img=a.querySelector('img');img.src='https://static.aldaindia.com/alda-assets/alda-'+f.image+'.webp';img.alt=name;
   const link=a.querySelector('a');link.href='/products/'+f.slug;link.setAttribute('aria-label','Shop '+name);
   a.querySelector('h3').textContent=name;
   priceLine(f,a.querySelector('.price'));
   return a;
  }
  const shown=()=>panels.map(p=>(p.querySelector('.panel-link')?.getAttribute('href')||'')+'|'+(p.querySelector('.price')?.textContent||'')).join(' ');
  // drawn again only when the pieces or their prices differ from what is showing; the featured stage keeps its place
  function draw(s,list){
   sale.hidden=!!(s&&!s.show)||!list.length;
   if(sale.hidden)return;
   const want=list.map(f=>'/products/'+f.slug+'|'+priceLine(f,document.createElement('div')).textContent).join(' ');
   if(want===shown())return;
   const active=Math.max(0,panels.findIndex(p=>p.classList.contains('active')));
   panels=list.map(panel);
   accordion.replaceChildren(...panels);
   bind();
   select(Math.min(active,panels.length-1));
  }
  // one pass at a time; prices that come in during one are drawn by another straight after
  let running=null,again=false;
  function update(){
   if(!window.aldaPrice||!window.aldaPrice.liveAt)return;
   if(running){again=true;return;}
   running=asked.then(s=>choose(s).then(list=>draw(s,list))).catch(()=>{}).then(()=>{running=null;if(again){again=false;update();}});
  }
  document.addEventListener('alda:prices',update);
  update();
 }

 if(reduce.matches||!window.gsap)return;
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(!entry.isIntersecting)return;
  const targets=entry.target.querySelectorAll('.reveal,.product-panel');
  gsap.from(targets,{y:36,opacity:0,duration:1,stagger:.075,ease:'power3.out',clearProps:'transform,opacity'});
  observer.unobserve(entry.target);
 }),{threshold:.12});
 root.querySelectorAll('section').forEach(section=>observer.observe(section));
 reduce.addEventListener('change',()=>{if(reduce.matches){observer.disconnect();const targets=root.querySelectorAll('.reveal,.product-panel');gsap.killTweensOf(targets);gsap.set(targets,{clearProps:'transform,opacity'});}});
})();
